import { render, staticRenderFns } from "./PreCheckoutSidebar.vue?vue&type=template&id=6bf20dbf&scoped=true"
import script from "./PreCheckoutSidebar.vue?vue&type=script&lang=js"
export * from "./PreCheckoutSidebar.vue?vue&type=script&lang=js"
import style0 from "./PreCheckoutSidebar.vue?vue&type=style&index=0&id=6bf20dbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf20dbf",
  null
  
)

export default component.exports